import { z } from 'zod';

export const dsl_parse_failed = z.object({
  error_class: z.enum(['lex', 'parse', 'reference', 'validation']),
  context: z.enum(['wizard', 'builder', 'import', 'load']),
}).strict();

export const migration_applied = z.object({
  kind: z.enum(['pattern', 'session', 'state', 'settings']),
  from_version: z.number().int().nonnegative(),
  to_version: z.number().int().positive(),
}).strict();

export const unknown_item_preserved = z.object({
  kind: z.enum(['pattern', 'session']),
  count: z.number().int().positive(),
}).strict();

// A local save failed. `quota` means the device is out of storage (the user
// is shown the SaveErrorBanner and is at risk of losing unsaved progress);
// `timeout` means the IndexedDB write never settled within the watchdog
// window (the WebKit post-background wedge; also reported to Sentry);
// `unknown` is any other write failure (also reported to Sentry).
export const save_failed = z.object({
  kind: z.enum(['quota', 'timeout', 'unknown']),
}).strict();

// A session mirror write was skipped. `size` means the serialized session
// exceeded the maximum size threshold to avoid localStorage quota exhaustion.
export const mirror_skipped = z.object({
  kind: z.enum(['size']),
}).strict();

// Boot-time reconciliation restored a session from the localStorage mirror
// because it was newer than (or absent from) the primary IDB blob.
export const session_recovered_from_mirror = z.object({}).strict();

// Boot-time load found the main state blob missing or unreadable and fell
// back to the previous-good backup generation.
export const state_recovered_from_backup = z.object({}).strict();
